import * as v from "valibot";
import { rpcContract } from "../rpc";

export const sendMailAddressValidationEmailRpcContract = rpcContract({
  name: "send-mail-address-validation-email",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    success: v.boolean(),
    email: v.string(),
  }),
});

export type SendMailAddressValidationEmailParams = v.InferOutput<
  typeof sendMailAddressValidationEmailRpcContract.paramsSchema
>;
export type SendMailAddressValidationEmailResult = v.InferOutput<
  typeof sendMailAddressValidationEmailRpcContract.resultSchema
>;
